import { CustomerAccountTabsItemProps } from '../../types';
import { CatTab } from '@blocks-react/components/Tab';

export const CustomerAccountTabsItem = ({
  key,
  children
}: CustomerAccountTabsItemProps) => {
  return <CatTab key={key}>{children}</CatTab>;
};
